"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { twMerge } from "tailwind-merge"
import { useStores } from "../../../../../../../hook/useStores"
import StoreLocatorContent from "./components/StoreLocatorContent"
import StoreLocatorSkeleton from "./components/StoreLocatorSkeleton"
import { transformStoreData } from "./utils/utils"

export interface StoreLocatorProps {
    title?: string
    className?: string
}

export const RenderConfig: ComponentConfig<StoreLocatorProps> = {
    render: ({ title, className }) => {
        const params = useParams()
        const storeLocale = useUIBuilderLocaleStore(state => state.locale)
        const locale = (params?.locale as string) || storeLocale || "vi"
        const { stores: rawStores, loading, error } = useStores({ pageSize: 100, sort: "createdAt:asc" }, locale)

        const stores = transformStoreData(rawStores)

        if (loading) {
            return (
                <StoreLocatorSkeleton />
            )
        }

        return (
            <div className={twMerge("w-full max-w-[1304px] mx-auto mt-[60px] sm:px-2 px-4", className)}>
                <StoreLocatorContent stores={stores} title={title} locale={locale} />
            </div>
        )
    },
}
